import { Dialog, Transition } from '@headlessui/react'
import classNames from 'classnames'
import { isFunction } from 'lodash'
import { Fragment } from 'react'
import usePopupStore from '../../../../../store/usePopupStore'

interface ICalendarModal {
  id: string
}

const CalendarModal = (props: ICalendarModal) => {
  const { id } = props
  const data = usePopupStore((state) => state.data[id])
  const { body = undefined, buttons = undefined } = data ? data : {}
  const popupClose = usePopupStore((state) => state.close)
  const closeModal = () => {
    popupClose({ id })
  }
  const { onClose = null } = data ? data : {}
  const open = data ? true : false
  const closeHandler = () => {
    popupClose({ id })
    if (isFunction(onClose)) {
      onClose()
    }
  }

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-[1000]" onClose={closeHandler}>
        {/* BackDrop */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="bg-dim fixed inset-0" />
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="min-h-[417px] min-w-[328px] transform overflow-hidden rounded-[12px] align-middle transition-all">
                <>
                  <div className={`z-[10000] rounded-[12px] bg-white py-[24px] px-[20px]`}>
                    {/* Calendar */}
                    {body}
                    {/* button wrapper*/}
                    <div className={`mt-[24px] flex w-full gap-[8px] text-center`}>
                      <button
                        className={classNames(styles.button.container, styles.button.left)}
                        onClick={buttons?.left?.onClick ?? closeModal}
                      >
                        {buttons.left.label}
                      </button>
                      <button
                        className={classNames(styles.button.container, styles.button.right)}
                        onClick={buttons?.right?.onClick}
                      >
                        {buttons.right.label}
                      </button>
                    </div>
                  </div>
                </>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}
export default CalendarModal

const styles = {
  button: {
    container: `w-full cursor-none select-none rounded-[7px] py-[12px] px-[28px] font-medium`,
    left: `border-[1.5px] border-gray-300`,
    right: `bg-purple-500 text-white`,
  },
}
